import { createSelector } from 'reselect'

import { isAuthentified } from 'data/auth/selectors'
import { getCurrentUser } from 'data/users/selectors'

export const isBootstrapped = state => state.app.started
export const bootstrapError = state => state.app.error

export const isSignedIn = createSelector(
  isBootstrapped,
  isAuthentified,
  getCurrentUser,
  (bootstrapped, authentified, viewer) =>
    bootstrapped && authentified && Boolean(viewer)
)

export const shouldSignIn = createSelector(
  isBootstrapped,
  isAuthentified,
  (bootstrapped, authentified) => bootstrapped && !authentified
)
